import { connect } from "react-redux";
import * as Redux from "redux";
import { getSchema, getReport, editForm, flushReport } from "../../actions";
import EditReport from "./component";

const mapStateToProps = (state: any): any => {
  return {
    report: state.reportForm
  };
};

const mapDispatchToProps = (dispatch: Redux.Dispatch<any>): any => {
  return {
    ...Redux.bindActionCreators(
      { getSchema, getReport, editForm, flushReport },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditReport);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/components/EditReport/container.ts